import { globalVariables } from "helper/globalVariables";
import { PieChart } from "../Charts/Pie";
import BarChart from "../Charts/BarChart";
import Loader from "shared/Components/loader";
import { useEffect, useState } from "react";

const TitalAnalytics = ({ TitleAnalyticsData, loading }) => {
  const city = TitleAnalyticsData?.titlesEarnedCity.map((item) => item.city);
  const trialCount = TitleAnalyticsData?.titlesEarnedCity.map(
    (item) => item.trialCount
  );

  const breed = TitleAnalyticsData?.titlesEarnedBreed.map((item) => item.breed);
  const breedCount = TitleAnalyticsData?.titlesEarnedBreed.map(
    (item) => item.breedCount
  );
  const calculateRepeatedData = (data, key) => {
    const counts = {};
    let maxCount = 0;

    data?.forEach((item) => {
      const { [key]: category, count } = item;

      counts[category] = (counts[category] || 0) + count;

      if (counts[category] > maxCount) {
        maxCount = counts[category];
      }
    });

    const repeatedCategories = Object.keys(counts).filter(
      (category) => counts[category] === maxCount
    );

    if (repeatedCategories.length === 0) {
      return data;
    } else {
      return data.filter((item) => repeatedCategories.includes(item[key]));
    }
  };

  const [repeatedBreedsData, setRepeatedBreedsData] = useState([]);
  const [repeatedCitiesData, setRepeatedCitiesData] = useState([]);

  useEffect(() => {
    if (!TitleAnalyticsData) return;

    const { titlesEarnedBreed, titlesEarnedCity } = TitleAnalyticsData;

    const repeatedBreeds = calculateRepeatedData(titlesEarnedBreed, "breed");
    const repeatedCities = calculateRepeatedData(titlesEarnedCity, "city");

    setRepeatedBreedsData(repeatedBreeds);
    setRepeatedCitiesData(repeatedCities);
  }, [TitleAnalyticsData]);

  function findLargestValue(arr, key) {
    return arr.reduce(
      (maxObject, currentObject) =>
        currentObject[key] > maxObject[key] ? currentObject : maxObject,
      arr[0]
    );
  }

  const LargestInMostTitleEarnedCity = () => {
    const item = findLargestValue(repeatedCitiesData, "trialCount");

    return (
      <label className="text-xs text-gray-600">
        {item?.trialCount && `${item?.city} (${item?.trialCount})`}
      </label>
    );
  };

  const LargestInMostTitleEarnedBreed = () => {
    const item = findLargestValue(repeatedBreedsData, "breedCount");
    return (
      <label className="text-xs text-gray-600">
        {item?.breedCount && `${item?.breed} (${item?.breedCount})`}
      </label>
    );
  };

  if (!TitleAnalyticsData) return null; 

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="grid md:grid-cols-3 gap-4 mt-[20px]">
          <div className="h-[100%] max-h-[600px]">
            <div className="w-[100%] rounded-md shadow-100 bg-white flex flex-col items-center py-[20px]">
              <label className="text-md font-normal text-gray-900">
                {globalVariables.noOfDogsEarned}
              </label>
              <span className="font-semibold text-xl">
                {TitleAnalyticsData?.noOfTitles}
              </span>
            </div>

            <div
              className={`w-[100%] shadow-100 rounded-md bg-white mt-[4%] ${
                TitleAnalyticsData.titlesEarnedAge?.length === 0
                  ? "h-[55%]"
                  : "h-[79%] max-h-[600px]"
              }`}
            >
              <div className="px-[15px] border-b-[1px] border-gray-100 py-[12px]">
                <div>
                  <label className="text-md font-bold text-gray-900">
                    {globalVariables.ageRange}
                  </label>
                </div>
                {TitleAnalyticsData.titlesEarnedAge?.length === 0 ? (
                  ""
                ) : (
                  <label className="text-xs text-gray-600">
                    {globalVariables.yearsOld}
                  </label>
                )}
              </div>

              <div className="h-[80%] py-[10px] px-[15px] flex justify-center items-center">
                {TitleAnalyticsData.titlesEarnedAge?.length === 0 ? (
                  <div className="font-semibold ">
                    {globalVariables.noDataAvailable}
                  </div>
                ) : (
                  <BarChart titleAnalytics={TitleAnalyticsData} />
                )}
              </div>
            </div>
          </div>

          <div className="w-[100%] shadow-100 rounded-md bg-white h-[100%] max-h-[600px] md:h-[99%] pb-[20px]">
            <div className="px-[15px] border-b-[1px] border-gray-100 py-[12px]">
              <div>
                <label className="text-md font-bold text-gray-900">
                  {globalVariables.mostTitleEarnedbyState}
                </label>
              </div>

              <LargestInMostTitleEarnedCity />
            </div>

            <div className="h-[87%] px-[15px] flex justify-center items-center">
              {city.length === 0 ? (
                <div className="font-semibold ">
                  {globalVariables.noDataAvailable}
                </div>
              ) : (
                <PieChart dataValue={city} dataCount={trialCount} />
              )}
            </div>
          </div>

          <div className="w-[100%] shadow-100 rounded-md bg-white h-[100%] max-h-[600px] overflow-auto md:h-[99%] pb-[20px]">
            <div className="px-[15px] border-b-[1px] border-gray-100 py-[12px]">
              <div>
                <label className="text-md font-bold text-gray-900">
                  {globalVariables.mostTitleEarnedbyBreed}
                </label>
              </div>
              <LargestInMostTitleEarnedBreed />
            </div>
            <div className="h-[87%] px-[15px] flex justify-center items-center">
              {breed.length === 0 ? (
                <div className="font-semibold ">
                  {globalVariables.noDataAvailable}
                </div>
              ) : (
                <PieChart dataValue={breed} dataCount={breedCount} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default TitalAnalytics;
